import React, { useState } from 'react'

import { motion } from "framer-motion";
import { fadeIn, textVariant } from "../utils/motion";

import vivaceLogo from "/vivace_logo.webp"
import fbLogo from "/facebook.svg"
import twitterLogo from "/twitter.svg"
import linkedinLogo from "/linkedin.svg"

const emailGeneral = import.meta.env.VITE_EMAIL_GENERAL;
const whatsappGeneral = import.meta.env.VITE_WA_GENERAL;
const phoneGeneral = import.meta.env.VITE_PHONE_GENERAL;

const Footer = () => {
  const [showEmail, setShowEmail] = useState(false);
  const footerLinks = {
    company: [
      { name: 'About', href: '#about' },
      { name: 'Terms of Use', href: '#newsletter' },
      { name: 'How it Works', href: '#howitworks' },
    ],

    support: [
      { name: 'FAQ', href: '#newsletter' },
      { name: 'Business', href: '#newsletter' },
      { name: 'Policy', href: '#newsletter' },
    ],
    contact: [
      {
        name: "WhatsApp",
        href: "#footer",
        onClick: () => {
          setShowEmail(true);
          setTimeout(() => setShowEmail(false), 9000); // fades out
        }
      },
      {
        name: "Support 24h",
        href: "#footer",
        onClick: () => {
          setShowEmail(true);
          setTimeout(() => setShowEmail(false), 9000); // fades out
        }
      },
      {
        name: "Email",
        href: "#footer",
        onClick: () => {
          setShowEmail(true);
          setTimeout(() => setShowEmail(false), 9000); // fades out
        }
      }
    ],
  }

  return (
    <motion.footer
      variants={fadeIn('up', 0.2)}
      initial="hidden"
      whileInView="show"
      className="bg-gray-50"
    >
      <div className="section-container lg:container lg:mx-auto mx-10">
        <motion.div
          variants={fadeIn('up', 0.3)}
          className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-12"
        >
          {/* Brand Column */}
          <motion.div
            variants={fadeIn('right', 0.4)}
            className="lg:col-span-4"
          >
            <motion.div
              variants={fadeIn('down', 0.5)}
              className="flex items-center gap-1 mb-6"
            >

              <div className="flex items-center">
                <img
                  src={vivaceLogo} // path to your logo
                  alt="Logo"
                  className="w-18 h-6 rounded-full opacity-90" // adjust size and style as needed
                />

              </div>


              <span className="text-xl font-medium ml-1">Vivace International</span>
            </motion.div>
            <motion.p
              variants={fadeIn('up', 0.6)}
              className="text-gray-600 mb-6"
            >
              A Multi-Product Company
            </motion.p>
            <motion.div
              variants={fadeIn('up', 0.7)}
              className="flex gap-4"
            >
              <motion.a
                whileHover={{ scale: 1.1 }}
                href="#"
                className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 hover:bg-blue-600 hover:text-white transition-colors"
              >
                <img src={fbLogo} alt="Facebook" className="w-6 h-6" />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1 }}
                href="#"
                className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 hover:bg-blue-400 hover:text-white transition-colors"
              >
                <img src={twitterLogo} alt="Facebook" className="w-6 h-6" />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1 }}
                href="#"
                className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 hover:bg-blue-700 hover:text-white transition-colors"
              >
                <img src={linkedinLogo} alt="Facebook" className="w-6 h-6" />
              </motion.a>
            </motion.div>
          </motion.div>

          {/* Links Columns */}
          <motion.div
            variants={fadeIn('left', 0.4)}
            className="lg:col-span-8"
          >
            <div className="grid grid-cols-3 md:grid-cols-4 gap-8">
              {Object.entries(footerLinks).map(([category, links], categoryIndex) => (
                <motion.div
                  key={category}
                  variants={fadeIn('up', 0.3 * (categoryIndex + 1))}
                >
                  <motion.h3
                    variants={textVariant(0.2)}
                    className="text-lg font-medium mb-4"
                  >
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                  </motion.h3>
                  <motion.ul
                    variants={fadeIn('up', 0.4)}
                    className="space-y-3"
                  >
                    {links.map((link, index) => (
                      <motion.li
                        key={index}
                        variants={fadeIn('up', 0.1 * (index + 1))}
                      >
                        <motion.a
                          whileHover={{ x: 5 }}
                          href={link.href}
                          onClick={link.onClick}
                          className="text-gray-600 hover:text-gray-900"
                        >
                          {link.name}
                        </motion.a>
                      </motion.li>
                    ))}
                  </motion.ul>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>

        {/* Copyright */}
        <motion.div
          variants={fadeIn('up', 0.8)}
          className="border-t border-gray-200 mt-12 pt-8"
        >
          <motion.div
            variants={fadeIn('up', 0.9)}
            className="flex flex-col md:flex-row justify-between items-center gap-4"
          >
            <motion.p
              variants={fadeIn('right', 1.0)}
              className="text-gray-600 text-sm"
            >
              Copyright © {new Date().getFullYear()} Vivace International
            </motion.p>
          </motion.div>
        </motion.div>
      </div>
      {/* FADE-IN / FADE-OUT EMAIL POPUP */}
      {showEmail && (
        <div
          className="absolute bottom-[50vh] left-1/2 -translate-x-1/2 z-[1000]
               bg-blue-100 text-blue-700 py-6 px-8 w-[90%] max-w-xl
               rounded-lg shadow-xl animate-fadeInOut
               flex flex-col items-center gap-4 text-center"
        >
          <div className="text-2xl font-bold">Contact Information</div>

          <div className="flex flex-col gap-2 text-xl">
            <p><span className="font-semibold">Email:</span> {emailGeneral}</p>
            <p><span className="font-semibold">WhatsApp:</span> {whatsappGeneral}</p>
            <p><span className="font-semibold">Support 24h:</span> {phoneGeneral}</p>
          </div>
        </div>
      )}


    </motion.footer>
  )
}

export default Footer